<div if.bind="scraperReport.panelOpen" class="modal-overlay" click.trigger="scraperReport.closePanel()">
  <div class="scraper-report-admin" click.trigger="$event.stopPropagation()">
    <div class="scraper-report-admin__header">
      <h3 class="scraper-report-admin__title">Scraper Report</h3>
      <button type="button" class="scraper-report-admin__close" click.trigger="scraperReport.closePanel()" aria-label="Close"><span class="icon icon--close" aria-hidden="true"></span></button>
    </div>

    <div class="scraper-report-admin__body">
      <p class="scraper-report-admin__hint">
        When each source last stored a release. &ldquo;Last scrape&rdquo; is the last time the source wrote any
        row at all; &ldquo;last new item&rdquo; is the last time it found something it had not seen before. A source
        that has not scraped in days has probably stopped working.
      </p>

      <div class="scraper-report-admin__toolbar">
        <span if.bind="!scraperReport.loading" class="scraper-report-admin__count">
          ${scraperReport.rows.length} source${scraperReport.rows.length === 1 ? '' : 's'}<span if.bind="scraperReport.problemCount > 0" class="scraper-report-admin__count-bad">, ${scraperReport.problemCount} need${scraperReport.problemCount === 1 ? 's' : ''} attention</span>
        </span>
        <button type="button" class="login-btn login-btn--secondary" click.trigger="scraperReport.load()" disabled.bind="scraperReport.loading">Refresh</button>
      </div>

      <div if.bind="scraperReport.error" class="scraper-report-admin__error">${scraperReport.error}</div>
      <div if.bind="scraperReport.loading" class="scraper-report-admin__status">Loading scraper report&hellip;</div>

      <div if.bind="!scraperReport.loading && scraperReport.rows.length === 0 && !scraperReport.error" class="scraper-report-admin__status">
        No registered sources.
      </div>

      <div if.bind="!scraperReport.loading && scraperReport.rows.length > 0" class="scraper-report-admin__table-wrap">
        <table class="scraper-report-admin__table">
          <thead>
            <tr>
              <th>Source</th>
              <th>Status</th>
              <th>Last scrape</th>
              <th>Last new item</th>
              <th class="scraper-report-admin__num">Releases</th>
            </tr>
          </thead>
          <tbody>
            <tr repeat.for="row of scraperReport.rows" class="scraper-report-admin__row scraper-report-admin__row--${scraperReport.health(row)}">
              <td class="scraper-report-admin__source">${row.source}</td>
              <td>
                <span class="scraper-report-admin__flag scraper-report-admin__flag--${scraperReport.health(row)}">
                  ${scraperReport.health(row) === 'ok' ? 'OK' : scraperReport.health(row) === 'warn' ? 'Check' : scraperReport.health(row) === 'stale' ? 'Stale' : scraperReport.health(row) === 'never' ? 'No data' : 'Disabled'}
                </span>
              </td>
              <td>${scraperReport.relative(row.lastUpdatedAt)}</td>
              <td>${scraperReport.relative(row.lastFirstSeenAt)}</td>
              <td class="scraper-report-admin__num">${row.releaseCount}</td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</div>
